
import { Component, Vue } from 'vue-property-decorator'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import { AppModule } from '@/store/modules/app'

@Component
export default class Preview extends Vue {
    private pdfh5: any = null

    headConfig = window.config.headConfig

    get robotName() {
      return AppModule.robotName
    }

    mounted () {
      this.pdfh5 = new Pdfh5('#pdf', {
        pdfurl: this.$route.params.url
      })
    }

    goback () {
      this.$router.go(-1)
    }
}
